module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.10782/images/homepage/hero-personas/hero-image-compressed.jpeg"